import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/carEngine.png'

function MotorNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Pain Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Motor</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default MotorNode
